import { IconPack } from "Explore/Config/Icons";
import styles from "./FavoriteEntityItem.module.scss";
import { IconButton } from "@mui/material";
import { numberRegex } from "Explore/Utils/numberRegex";
import { ImageCheck, LinkWrapper } from "Explore/Components";
import { ImageCheckType, ImageType } from "Explore/Config/ImageType";
import useFavoriteItem from "Explore/Hook/useFavoriteItem";
import FavoriteSnackbar from "Explore/Hook/FavoriteItemSnackbar";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";

const FavoriteUnitItem = ({ data }) => {
  const { deleteFavoriteItem, snackbarProps } = useFavoriteItem({
    itemId: data.id,
  });
  const [isDeleted, setIsDeleted] = useState(false);
  const statistics = [
    { value: data?.total_publication, icon: IconPack.publications },
    { value: data?.total_citation, icon: IconPack.citation },
    { value: data?.total_h_index, icon: IconPack.h_index },
    { value: data?.total_faculties, icon: IconPack.unit_faculty_members },
  ].filter((e) => !!e.value);

  const handleDelete = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    const result = await deleteFavoriteItem();
    if (result) {
      setIsDeleted(true); // Triggers exit animation
    }
  };

  return (
    <>
      <AnimatePresence>
        {!isDeleted && (
          <motion.div
            initial={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5 }}
            style={{ width: "100%" }}
          >
            <LinkWrapper
              link={`/explore/unit/${data?.explore_slug || data?.id}`}
              component={
                <div className={styles["container"]}>
                  <div className={styles["name--wrapper"]}>
                    <p className={styles["name"]}>{data?.name}</p>
                    <IconButton
                      color="error"
                      size="small"
                      onClick={(e) => handleDelete(e)}
                    >
                      {IconPack.delete}
                    </IconButton>
                  </div>
                  <div className={styles["bottom"]}>
                    <div className={styles["statistics"]}>
                      {statistics.map((item, index) => (
                        <div className={styles["statistics--item"]} key={index}>
                          {item.icon}
                          {numberRegex(item.value)}
                        </div>
                      ))}
                    </div>
                    <div className={styles["sub-bottom"]}>
                      <div className={styles["description--wrapper"]}>
                        <p className={styles["description"]}>
                          RESEARCH AREA: <br />
                          {data?.keywords?.join(", ")}
                        </p>
                        <p className={styles["position"]}>
                          {data?.institution_name}
                        </p>
                      </div>
                      <div className={styles["avatar"]}>
                        <ImageCheck
                          url={`https://media.academic.online/institutions_images/${data?.institution_id}/${ImageType.LANDSCAPE}.png`}
                          type={ImageCheckType.INSTITUTION_LOGO}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              }
            />
          </motion.div>
        )}
      </AnimatePresence>
      <FavoriteSnackbar {...snackbarProps} />
    </>
  );
};

export default FavoriteUnitItem;
